<div class="wrapper selenium-language-selector">
    <ng-select
        [items]="items"
        bindLabel="language"
        dropdownPosition="bottom"
        [multiple]="false"
        [hideSelected]="false"
        [searchable]="false"
        [clearable]="false"
        [markFirst]="true"
        placeholder="Language"
        [ngModel]="selectedItem"
        (change)="selectedItemChange.emit($event)"
        class="selector"
    >
    </ng-select>
    <app-icon [type]="'Globe'"></app-icon>
</div>
